import { writable } from 'svelte/store';

export const loadingData = writable(false);
